import { render, staticRenderFns } from "./Franchise.vue?vue&type=template&id=e31c6ac2&scoped=true&"
import script from "./Franchise.vue?vue&type=script&lang=js&"
export * from "./Franchise.vue?vue&type=script&lang=js&"
import style0 from "./Franchise.vue?vue&type=style&index=0&id=e31c6ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31c6ac2",
  null
  
)

export default component.exports